import { DropdownButton, SelectList } from 'ui'
import styled, { css } from 'styled-components'
import { giphyBlue, giphyGreen } from '@giphy/js-brand'
import isMobile from 'shared/util/is-mobile'

const StyledDropdownButton = styled(DropdownButton)`
    position: relative;
    width: 215px;

    ${() =>
        isMobile() &&
        css`
            width: 140px;
        `}
`

const values: string[] = ['GIFs & Stickers', 'Clips', 'GIFs', 'Stickers', 'Stories']

type Props = {
    onChange: (type: string) => void
    selectedContentType: string
}

const ContentTypePicker = ({ onChange = () => {}, selectedContentType }: Props) => {
    const selectedValue = values.findIndex((value) => value === selectedContentType)

    return (
        <StyledDropdownButton
            label={'Content Type'}
            iconButtonOptions={{
                iconColor: giphyBlue,
            }}
        >
            <SelectList
                defaultIndex={selectedValue}
                options={values}
                onChange={(index) => {
                    onChange(values[index])
                }}
                iconColor={giphyGreen}
            />
        </StyledDropdownButton>
    )
}

export default ContentTypePicker
